import { Laya } from "../../../../Laya";
import { BufferUsage } from "../../../RenderEngine/RenderEnum/BufferTargetType";
import { Laya3DRender } from "../../../d3/RenderObjs/Laya3DRender";
import { IndexBuffer3D } from "../../../d3/graphics/IndexBuffer3D";
import { VertexBuffer3D } from "../../../d3/graphics/VertexBuffer3D";
export class LengencyRenderEngine3DFactory {
    createVertexBuffer3D(byteLength, bufferUsage, canRead = false) {
        return new VertexBuffer3D(byteLength, bufferUsage, canRead);
    }
    createIndexBuffer3D(indexType, indexCount, bufferUsage = BufferUsage.Static, canRead = false) {
        return new IndexBuffer3D(indexType, indexCount, bufferUsage, canRead);
    }
}
Laya.addBeforeInitCallback(() => {
    if (!Laya3DRender.renderOBJCreate)
        Laya3DRender.renderOBJCreate = new LengencyRenderEngine3DFactory();
});
